import { getNullLogger } from "@uniformdev/common";
import { v4 as uuid } from 'uuid';
export function createUniformUnsubscribe(unsub) {
  return {
    id: uuid(),
    unsub: unsub
  };
}
export function getSubscriptionManager(id, isGlobal, logger) {
  if (isGlobal === void 0) {
    isGlobal = false;
  }
  if (logger === void 0) {
    logger = getNullLogger();
  }
  logger.debug("getSubscriptionManager - Getting subscription manager.", {
    id: id,
    isGlobal: isGlobal
  });
  var map = new Map();
  return {
    id: id,
    getSubscribers: function getSubscribers(type) {
      var _a;
      return (_a = map.get(type)) !== null && _a !== void 0 ? _a : [];
    },
    getSubscriptionTypes: function getSubscriptionTypes() {
      var types = [];
      Array.from(map.keys()).forEach(function (type) {
        if (type) types.push(type);
      });
      return types;
    },
    publish: function publish(data) {
      var _a;
      logger.debug("Default subscription manager - Publish", {
        id: id,
        data: data
      });
      if (data.silent === true) {
        return;
      }
      var callbacks = map.get(data.type);
      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback(data);
        });
      }
      var callbacks2 = map.get(undefined);
      if (callbacks2) {
        callbacks2.forEach(function (callback) {
          return callback(data);
        });
      }
      if (isGlobal != true) {
        if ((_a = window.uniform) === null || _a === void 0 ? void 0 : _a.subscriptions) {
          window.uniform.subscriptions.publish(data);
        }
      }
    },
    subscribe: function subscribe(type, callback) {
      logger.debug("Default subscription manager - Subscribe", {
        id: id,
        type: type,
        callback: callback
      });
      var callbacks = map.get(type);
      if (!callbacks) {
        callbacks = [];
        map.set(type, callbacks);
      }
      if (callbacks.indexOf(callback) == -1) {
        callbacks.push(callback);
        map.set(type, callbacks);
      }
      var unsub = function unsub() {
        var position = callbacks.indexOf(callback);
        if (position == -1) {
          return false;
        }
        callbacks.splice(position, 1);
        return true;
      };
      return createUniformUnsubscribe(unsub);
    }
  };
}